import app from 'flarum/forum/app';

/**
 * Shared helpers for the BlueEmotion homepage section components (./Home*.tsx).
 */

/**
 * Primary (top-level) tags, ordered by position.
 *
 * flarum/tags preloads tags into the store, so this is synchronous. Primary
 * tags have a `position` and no parent. Defensive: if the tags extension is
 * absent the cast/guards simply yield an empty array.
 */
export function primaryTags() {
  return app.store.all('tags').filter(t => {
    var _t$parent;
    return typeof t.position === 'function' && t.position() !== null && t.position() !== undefined && !((_t$parent = t.parent) != null && _t$parent.call(t));
  }).sort((a, b) => a.position() - b.position());
}

/** Compact relative-time label, e.g. `12m`, `3h`, `5d`. */
export function relTime(date) {
  try {
    const diff = Date.now() - new Date(date).getTime();
    const day = 86400000;
    if (diff < 3600000) return Math.max(1, Math.round(diff / 60000)) + 'm';
    if (diff < day) return Math.round(diff / 3600000) + 'h';
    return Math.round(diff / day) + 'd';
  } catch (_unused) {
    return '';
  }
}
flarum.reg.add('glowingblue-demo', 'forum/components/home/utils', { primaryTags: primaryTags,relTime: relTime, });